var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('LoginModal',{attrs:{"visible":_vm.showLoginModal,"type":_vm.loginModalType,"z-index":9999},on:{"close":_vm.closeLoginModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }